/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Careers page
    $(() => {
      $('.career-tile').matchHeight();
    });
  },
  finalize() {
    // JavaScript to be fired on the Careers page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/careers.js